<template>
  <div class="mt-6 text-right">
    <h2 class="text-lg font-semibold mb-2">{{ $t("skills") }}</h2>
    <transition-group
      name="skill-fade"
      tag="div"
      class="flex flex-wrap gap-2 justify-end"
    >
      <span
        v-for="skill in skills"
        :key="skill.id"
        :class="[
          'px-4 py-2 rounded-lg text-sm transition-all duration-500 shadow-sm backdrop-blur-sm',
          highlightedSkillIds.includes(skill.id)
            ? 'shadow-md text-gray-900'
            : 'bg-gray-100/80 text-gray-900',
        ]"
        :style="
          highlightedSkillIds.includes(skill.id)
            ? 'background: linear-gradient(90deg, #A4C9A2 0%, #C2F5D4 100%);'
            : ''
        "
      >
        {{ skill.name }}
      </span>
    </transition-group>
  </div>
  <div class="mt-6 text-right">
    <h2 class="text-lg font-semibold mb-2">{{ $t("learningSkills") }}</h2>
    <span
      class="px-4 py-2 rounded-lg text-sm shadow-sm backdrop-blur-sm bg-gray-100/80 text-gray-900 justify-end"
    >
      React
    </span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { skills, Skill } from "@/data/skills";

@Options({
  props: {
    highlightedSkillIds: {
      type: Array as () => string[],
      default: () => [],
    },
  },
})
export default class SkillsList extends Vue {
  readonly highlightedSkillIds!: string[];
  skills: Skill[] = skills;
}
</script>

<style scoped>
.skill-fade-enter-active,
.skill-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.77, 0, 0.175, 1);
}
.skill-fade-enter-from,
.skill-fade-leave-to {
  opacity: 0;
  transform: scale(0.85) translateY(10px);
}
.skill-fade-leave-active {
  position: absolute;
}
.glossy::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 0.5rem; /* match rounded-lg */
  pointer-events: none;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0.55) 0%,
    rgba(255, 255, 255, 0.15) 40%,
    rgba(255, 255, 255, 0.05) 100%
  );
  mix-blend-mode: lighten;
}
</style>
